import { PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import { H2, Text } from 'library/atoms/Typography'
import useTranslation from 'next-translate/useTranslation'
import NotifierContent, { NotifierContentActions } from '../NotifierContent'
import { NotifierWrapper } from '../NotifierRestrictedAccess/NotifierRestrictedAccess'
import { IconNames } from 'enums/iconNames'

export interface NotifierErrorMessageProps extends PropsWithChildren<unknown> {
  errorMessage?: string
  headingText?: string
  subText?: string
  iconName?: IconNames
}

const NotifierErrorMessage = ({
  children,
  headingText,
  subText,
  errorMessage,
  iconName = 'warning'
}: NotifierErrorMessageProps) => {
  const { t } = useTranslation('common')

  return (
    <NotifierWrapper>
      <StyledNotifierContent staticIcon={iconName} iconColor="error">
        <H2>{headingText ? headingText : t('error-message-title')}</H2>
        {errorMessage && (
          <Text fontStyle="p4" color="tertiary" mt={2}>
            {errorMessage}
          </Text>
        )}
        <Text fontStyle="p3" color="secondary" mt={2}>
          {subText ? subText : t('error-message-byline')}
        </Text>
        {children && (
          <NotifierContentActions>{children}</NotifierContentActions>
        )}
      </StyledNotifierContent>
    </NotifierWrapper>
  )
}

export default NotifierErrorMessage

const StyledNotifierContent = styled(NotifierContent)(({ theme }) => ({
  boxShadow: theme.shadows[1],
  borderRadius: theme.radii[2],
  minWidth: theme.contentMaxWidth.xs,
  textAlign: 'center'
}))
